import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronReduceY = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16.2426 4.92896L12 9.1716L7.75736 4.92896", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M7.75735 19.071L12 14.8284L16.2426 19.071", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconChevronReduceY.js.map